var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState, useRef, createRef, useCallback } from 'react';
import ImagesContainer from './ImagesContainer';
import TextContainer from './TextContainer';
import ExtrasContainer from './ExtrasContainer';
import GalleryCanvas from './GalleryCanvas';
import { s3 } from '../../helpers/awsConfig';
import WarningPopup from './WarningPopup';
import { createPortal } from 'react-dom';
import ExportCanvas from './ExportCanvas';
import AddToCartModal from './AddToCartModal';
import SizeGuideModal from './SizeGuideModal';
import { getURLParam } from '../../helpers/urlParams';
import cartUtil from '../../helpers/cartUtil';
import Loader from './Loader';
import PreviewCanvas from './PreviewCanvas';
import { debounce } from 'debounce';
import { generateUID, getMelbourneDateString } from '../../helpers/date';
import AddToCartButton from './AddToCartButton';
import { removeSpaces, moveIndex } from '../../helpers/helpers';
import DesignButton from '../atoms/DesignButton';
import PreviewButton from '../atoms/PreviewButton';
import ShelfBar from '../atoms/ShelfBar';
import InspoButton from '../atoms/InspoButton';
import ToolsContainer from './ToolsContainer';
const CustomiserBase = ({ productData, canvasContainer, atcContainer, templateCopy, templateSettings, exportContainer, inspoButtonContainer, designButtonContainer, previewButtonContainer, shelfContainer, }) => {
    const { images, text, background_images, canvas, texture_mask, textures, cut_out_images, overlay_stickers, max_file_size, max_dimensions, min_dimensions, use_ryanai, } = productData.design;
    const { settings, strings, product, isoCode } = productData;
    const errorMessages = {
        fileSize: {
            heading: strings.warning_title_file_size,
            body: strings.warning_message_file_size,
        },
        fileType: {
            heading: strings.warning_title_file_type,
            body: strings.warning_message_file_size,
        },
        fileLarge: {
            heading: strings.warning_title_file_large,
            body: strings.warning_message_file_large,
        },
        fileSmall: {
            heading: strings.warning_title_file_small,
            body: strings.warning_message_file_small,
        },
        maxUploads: {
            heading: strings.warning_title_max_uploads,
            body: strings.warning_message_max_uploads,
        },
        uploadError: {
            heading: strings.warning_title_file_error,
            body: strings.warning_message_file_error,
        },
        backgroundCutoutError: {
            heading: strings.warning_title_background,
            body: strings.warning_message_background,
        },
        addToCartError: {
            heading: strings.warning_title_add_to_cart,
            body: strings.warning_message_add_to_cart,
        },
    };
    const initImageState = (initialImageData) => {
        return {
            order: initialImageData.map((item, index) => index),
            images: initialImageData.map((image, posIndex) => {
                return {
                    initialIndex: posIndex,
                    uploadedImage: null,
                    loading: false,
                    placeholder: image.image_loading_placeholder,
                    position: {
                        height: Number(image.initial_height),
                        width: Number(image.initial_width),
                        pos_y: Number(image.initial_pos_y),
                        pos_x: Number(image.initial_pos_x),
                        rotation: Number(image.initial_rotation),
                    },
                };
            }),
        };
    };
    const initTextState = (textData) => {
        return textData.map((text) => {
            return {
                fontSize: Number(text.initial_font_size),
                initialFontSize: Number(text.initial_font_size),
                activeFont: text.fonts[0].font_name,
                activeFontStyle: text.fonts[0].font_style,
                activeColour: text.colours[0].colour_code,
                text: '',
                scale: 1,
            };
        });
    };
    const initialUploadState = {
        status: 'not-started',
        urls: {
            finalArtworkURL: '',
            previewArtworkURL: '',
            thumbnailArtworkURL: '',
        },
    };
    // Global state
    const canvasRef = useRef(null);
    const productImageRef = useRef(null);
    const imageToolsRef = useRef(null);
    const textInputRefs = useRef(text.map(() => createRef()));
    const previousWidth = useRef(window.innerWidth);
    const [galleryExpanded, setGalleryExpanded] = useState(true);
    const [designModeChecked, setDesignModeChecked] = useState(false);
    const [canvasScaler, setCanvasScaler] = useState({
        gallery: null,
        galleryThumbnail: null,
        exportPreview: null, // Desktop & Mobile: Preview Canvas for export
    });
    const [canvasMultiplier, setCanvasMultiplier] = useState({
        gallery: null,
    });
    const [selectedVariant, setSelectedVariant] = useState(product.variants[0]);
    const [canvasZoomed, setCanvasZoomed] = useState(false);
    // Image State
    const [imageState, setImageState] = useState(initImageState(images));
    const [uploadedImagesCount, setUploadedImagesCount] = useState(0);
    const [fileUploadError, setFileUploadError] = useState({ isError: null, timestamp: Date.now() });
    const [selectedImage, setSelectedImage] = useState(null); //image.initialIndex
    // Image Refs, used to move images
    const galleryImageRefs = useRef(images.map(() => createRef()));
    const exportCanvasImageRefs = useRef(images.map(() => createRef()));
    // Final exports
    const [sessionID, setSessionID] = useState(null);
    const [finalFileName, setFinalFileName] = useState(null);
    const [dailyFolderName] = useState(getMelbourneDateString());
    const [finalArtwork, setFinalArtwork] = useState(null);
    const [thumbnailImage, setThumbnailImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [addToCartModalOpen, setAddToCartModalOpen] = useState(false);
    const [addingToCart, setAddingToCart] = useState(false);
    const [generatingPreview, setGeneratingPreview] = useState(false);
    const [renderingExportCanvas, setRenderingExportCanvas] = useState(false);
    const [uploadingFinalArtwork, setUploadingFinalArtwork] = useState(initialUploadState);
    const [cartState, setCartState] = useState([]);
    const finalArtworkRef = useRef(null);
    const finalPreviewRef = useRef(null);
    const finalProductRef = useRef(null);
    // Text State
    const [textState, setTextState] = useState(initTextState(text));
    const [fontUpdated, setFontUpdate] = useState({ count: 0, index: 0 });
    const textRefs = useRef(text.map(() => createRef()));
    const finalTextRefs = useRef(text.map(() => createRef()));
    const finalImageRefs = useRef(images.map(() => createRef()));
    // Extras State
    const [selectedBackgroundImage, setSelectedBackgroundImage] = useState(null);
    const [selectedSticker, setSelectedSticker] = useState(null);
    const [selectedTextures, setSelectedTextures] = useState({ belowText: [], aboveText: [], mask: null });
    // Export Scaling
    const [deviceScaler, setDeviceScaler] = useState(null);
    const [pixelRatio, setPixelRatio] = useState(null);
    useEffect(() => {
        // initialise variant button listeners
        const variantButtons = document.querySelectorAll('variant-picker input');
        if (variantButtons) {
            Array.from(variantButtons).forEach((variantBtn) => {
                variantBtn.addEventListener('change', () => {
                    setTimeout(() => {
                        const newVariantID = getURLParam('variant');
                        const [newVariant] = product.variants.filter((variant) => {
                            return variant.id == Number(newVariantID);
                        });
                        if (newVariant) {
                            setSelectedVariant(newVariant);
                        }
                    }, 600);
                });
            });
            // Load variant from URL on first load
            const variantInURL = getURLParam('variant');
            if (variantInURL) {
                const [newVariant] = product.variants.filter((variant) => {
                    return variant.id == Number(variantInURL);
                });
                if (newVariant) {
                    setSelectedVariant(newVariant);
                }
            }
        }
        // Set the initial session
        setNewSession();
        const onWindowResize = debounce(() => {
            requestAnimationFrame(() => {
                if (previousWidth.current !== window.innerWidth) {
                    previousWidth.current = window.innerWidth;
                    setScalerVariables();
                }
            });
        }, 250);
        window.addEventListener('resize', onWindowResize);
        // Set device information
        const pixelRat = window.devicePixelRatio || 1;
        const isHighEndDevice = pixelRat > 2;
        const isLargeScreen = window.screen.width > 768;
        setPixelRatio(pixelRat > 1 ? pixelRat : 2);
        setDeviceScaler(isHighEndDevice && isLargeScreen ? 0.5 : 0.4);
        return () => {
            sessionStorage.removeItem('th-cust-session');
            window.removeEventListener('resize', onWindowResize);
        };
    }, []);
    useEffect(() => {
        setScalerVariables();
    }, [productImageRef.current]);
    // Resize event to reset scalers
    const setScalerVariables = () => {
        const imageHeight = Number(canvas.height) + Number(canvas.offset_bottom) + Number(canvas.offset_top);
        const scaler = {
            gallery: 0,
            galleryThumbnail: 64 / imageHeight,
            exportPreview: 900 / imageHeight,
        };
        const multiplier = {
            gallery: 0,
        };
        if (productImageRef && productImageRef.current) {
            scaler['gallery'] = productImageRef.current.clientHeight / imageHeight;
            multiplier['gallery'] = imageHeight / productImageRef.current.clientHeight;
        }
        setCanvasScaler(scaler);
        setCanvasMultiplier(multiplier);
    };
    useEffect(() => {
        if (selectedVariant && sessionID) {
            setNewFileName();
        }
    }, [selectedVariant, sessionID]);
    const setNewSession = () => {
        const uuid = generateUID();
        setSessionID(uuid);
    };
    const setNewFileName = () => {
        let selectedCode = null;
        if (product.color_option != '') {
            const colourCodes = settings.th_c_color_codes.split(',');
            selectedCode = colourCodes.find((entry) => {
                return removeSpaces(entry.split(':')[0]) == removeSpaces(selectedVariant[product.color_option]);
            });
        }
        let uniqueFilename = `${product.print_id}${selectedCode ? `-${selectedCode.split(':')[1]}` : '-WH'}_${sessionID}`;
        uniqueFilename = uniqueFilename.replace(/:/g, '-');
        setFinalFileName(uniqueFilename);
    };
    useEffect(() => {
        const uploadedImages = imageState.images.filter((image) => image.loading || image.uploadedImage != null);
        setUploadedImagesCount(uploadedImages.length);
    }, [imageState]);
    const setActiveImage = (imageindex) => {
        setSelectedImage(imageindex);
        const toolsContainer = imageToolsRef.current;
        if (toolsContainer && window.innerWidth < 1000) {
            const containerElem = toolsContainer.getBoundingClientRect();
            const headerHeight = window.innerWidth > 699 ? 84 : 60;
            const shelfHeight = 50;
            const canvasHeight = window.innerWidth;
            const scrollPosition = containerElem.top + window.scrollY - (headerHeight + shelfHeight + canvasHeight + 8);
            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
            });
        }
    };
    // Function to handle the image upload
    const handleImageUpload = (imageUrl, height, width, error, freeImageIndex) => __awaiter(void 0, void 0, void 0, function* () {
        if (error) {
            console.error(`Image upload error: ${error}`);
            setFileUploadError({ isError: error, timestamp: Date.now() });
            setImageLoadFailed(freeImageIndex);
            return;
        }
        setImageState((prevState) => {
            const freeImageSlot = prevState.images.find((item) => item.initialIndex === freeImageIndex);
            if (!freeImageSlot)
                return prevState;
            const multiplier = freeImageSlot.position.width / width;
            const updatedHeight = height * multiplier;
            const updatedWidth = freeImageSlot.position.width;
            const updatedImages = prevState.images.map((item) => {
                if (item.initialIndex === freeImageIndex) {
                    return Object.assign(Object.assign({}, item), { uploadedImage: imageUrl, loading: false, position: {
                            height: updatedHeight,
                            width: updatedWidth,
                            pos_x: item.position.pos_x + updatedWidth / 2,
                            pos_y: item.position.pos_y + updatedHeight / 2,
                            rotation: item.position.rotation,
                        } });
                }
                return item;
            });
            return Object.assign(Object.assign({}, prevState), { images: updatedImages });
        });
        // Automatically select the image
        setSelectedImage(freeImageIndex);
    });
    const setImageLoading = (freeImageIndex) => __awaiter(void 0, void 0, void 0, function* () {
        setImageState((prevState) => {
            const updatedImages = prevState.images.map((item) => {
                if (item.initialIndex === freeImageIndex) {
                    return Object.assign(Object.assign({}, item), { loading: true });
                }
                return item;
            });
            return Object.assign(Object.assign({}, prevState), { images: updatedImages });
        });
    });
    const setImageLoadFailed = (freeImageIndex) => __awaiter(void 0, void 0, void 0, function* () {
        setImageState((prevState) => {
            const updatedImages = prevState.images.map((item) => {
                if (item.initialIndex === freeImageIndex) {
                    return Object.assign(Object.assign({}, item), { loading: false });
                }
                return item;
            });
            return Object.assign(Object.assign({}, prevState), { images: updatedImages });
        });
    });
    const handleResetWarnings = () => {
        setFileUploadError({ isError: null, timestamp: Date.now() });
    };
    const removeImageFromS3 = (imageIndex, imageUrl) => __awaiter(void 0, void 0, void 0, function* () {
        const fileName = imageUrl.split('/').pop(); // Extract file name from URL
        yield setSelectedImage(null);
        const deleteParams = {
            Bucket: settings.customiser_s3_bucket,
            Key: fileName,
        };
        s3.deleteObject(deleteParams, (err, data) => {
            if (err) {
                console.error('Error deleting the file from S3: ', err.message);
            }
            else {
                console.log('File deleted successfully from S3');
                setImageState((prevState) => (Object.assign(Object.assign({}, prevState), { images: prevState.images.map((image) => image.initialIndex === imageIndex
                        ? Object.assign(Object.assign({}, image), { uploadedImage: null, loading: false, position: {
                                height: Number(images[imageIndex].initial_height),
                                width: Number(images[imageIndex].initial_width),
                                pos_x: Number(images[imageIndex].initial_pos_x),
                                pos_y: Number(images[imageIndex].initial_pos_y),
                                rotation: Number(images[imageIndex].initial_rotation),
                            } }) : image) })));
            }
        });
    });
    const updateImageDimensions = (imageIndex, dimensions) => {
        setImageState((prevState) => (Object.assign(Object.assign({}, prevState), { images: prevState.images.map((image) => image.initialIndex === imageIndex ? Object.assign(Object.assign({}, image), { position: Object.assign({}, dimensions) }) : image) })));
    };
    const handleToolClick = (direction) => {
        const currentImage = imageState.images.find((image) => image.initialIndex == selectedImage);
        const newPosition = Object.assign({}, currentImage.position);
        const aspectRatio = currentImage.position.width / currentImage.position.height;
        switch (direction) {
            case 'move-left':
                newPosition.pos_x -= 10;
                break;
            case 'move-right':
                newPosition.pos_x += 10;
                break;
            case 'move-down':
                newPosition.pos_y += 10;
                break;
            case 'move-up':
                newPosition.pos_y -= 10;
                break;
            case 'increase':
                newPosition.width += 10;
                newPosition.height = newPosition.width / aspectRatio;
                newPosition.pos_x -= 5;
                newPosition.pos_y -= 5;
                break;
            case 'decrease':
                if (newPosition.width > 10 && newPosition.height > 10) {
                    // Prevent size from going negative
                    newPosition.width -= 10;
                    newPosition.height = newPosition.width / aspectRatio;
                    newPosition.pos_x += 5;
                    newPosition.pos_y += 5;
                }
                break;
            case 'rotate-right':
                newPosition.rotation -= 10;
                break;
            case 'rotate-left':
                newPosition.rotation += 10;
                break;
            default:
                break;
        }
        updateImageDimensions(selectedImage, newPosition);
    };
    const handleLayerChange = (direction) => {
        const currentOrderIndex = imageState.order.indexOf(selectedImage);
        const currentIndex = imageState.images.findIndex((item) => item.initialIndex == selectedImage);
        switch (direction) {
            case 'back':
                if (galleryImageRefs.current[currentIndex] && galleryImageRefs.current[currentIndex].current) {
                    galleryImageRefs.current[currentIndex].current.moveDown();
                }
                if (exportCanvasImageRefs.current[currentIndex] && exportCanvasImageRefs.current[currentIndex].current) {
                    exportCanvasImageRefs.current[currentIndex].current.moveDown();
                }
                setImageState((prevState) => {
                    return Object.assign(Object.assign({}, prevState), { order: moveIndex(prevState.order, currentOrderIndex, 'down') });
                });
                break;
            case 'front':
                if (galleryImageRefs.current[currentIndex] && galleryImageRefs.current[currentIndex].current) {
                    galleryImageRefs.current[currentIndex].current.moveUp();
                }
                if (exportCanvasImageRefs.current[currentIndex] && exportCanvasImageRefs.current[currentIndex].current) {
                    exportCanvasImageRefs.current[currentIndex].current.moveUp();
                }
                setImageState((prevState) => {
                    return Object.assign(Object.assign({}, prevState), { order: moveIndex(prevState.order, currentOrderIndex, 'up') });
                });
                break;
            default:
                break;
        }
    };
    const handleFocusTextInput = (textInputRef) => __awaiter(void 0, void 0, void 0, function* () {
        if (textInputRef && window.innerWidth < 1000) {
            yield setGalleryExpanded(false);
            setTimeout(() => {
                const containerElem = textInputRef.getBoundingClientRect();
                const headerHeight = window.innerWidth > 699 ? 84 : 60;
                const shelfHeight = 50;
                const canvasHeight = window.innerWidth / 2;
                const scrollPosition = containerElem.top + window.scrollY - (headerHeight + shelfHeight + canvasHeight + 46);
                window.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth',
                });
            }, 300);
        }
    });
    const handleTextInput = (textInput, textIndex) => {
        if (textInput.length > text[textIndex].max_character_count) {
            return;
        }
        const updatedTextState = textState;
        let updatedText = textInput;
        if (text[textIndex].all_caps == true) {
            updatedText = updatedText.toUpperCase();
        }
        updatedTextState[textIndex] = Object.assign(Object.assign({}, textState[textIndex]), { text: updatedText });
        setTextState([...updatedTextState]);
        setFontUpdate({ count: fontUpdated.count + 1, index: textIndex });
    };
    const handleTextColourChange = (newColour, textIndex) => {
        const updatedTextState = textState;
        updatedTextState[textIndex] = Object.assign(Object.assign({}, textState[textIndex]), { activeColour: newColour });
        setTextState([...updatedTextState]);
    };
    const handleFontChange = (newFont, newStyle, textIndex) => {
        const updatedTextState = textState;
        updatedTextState[textIndex] = Object.assign(Object.assign({}, textState[textIndex]), { activeFont: newFont, activeFontStyle: newStyle });
        setTextState([...updatedTextState]);
        setFontUpdate({ count: fontUpdated.count + 1, index: textIndex });
    };
    const handleFontSizeChange = (newSize, textIndex) => {
        const updatedTextState = textState;
        updatedTextState[textIndex] = Object.assign(Object.assign({}, textState[textIndex]), { fontSize: newSize });
        setTextState([...updatedTextState]);
    };
    // Text is updated
    useEffect(() => {
        setTimeout(() => {
            const textData = textRefs.current[fontUpdated.index];
            const baseFontSize = textState[fontUpdated.index].fontSize;
            let wrapText;
            if (text[fontUpdated.index]) {
                wrapText = text[fontUpdated.index].wrap_text;
            }
            if (wrapText != true) {
                let scale = 1;
                if (textData && textData.current) {
                    const allText = textData.current.text();
                    const clientRect = textData.current.measureSize(allText);
                    const containerWidth = Number(canvas.width) * canvasScaler.gallery;
                    scale = containerWidth / (clientRect.width + 5);
                    const newFontSize = Number(baseFontSize) * scale;
                    setTextState((prevState) => prevState.map((item, index) => index == fontUpdated.index
                        ? Object.assign(Object.assign({}, item), { fontSize: newFontSize < Number(item.initialFontSize)
                                ? Number(item.fontSize) * scale
                                : Number(item.initialFontSize) }) : item));
                }
            }
        }, 100);
    }, [fontUpdated]);
    const setStickerOnClick = (index) => {
        if (selectedSticker != overlay_stickers[index]) {
            setSelectedSticker(overlay_stickers[index]);
        }
    };
    const setBackgroundOnClick = (index) => {
        if (selectedBackgroundImage != background_images[index]) {
            setSelectedBackgroundImage(background_images[index]);
        }
    };
    const setCustomiserActive = () => {
        const designToggle = document.querySelector('[name="toggle_view"][value="Design"]');
        if (designToggle) {
            designToggle.click();
        }
        if (!hasUnsavedChanges) {
            setHasUnsavedChanges(true);
            const lastSession = sessionStorage.getItem('th-cust-session');
            if (lastSession) {
                // console.warn('THREADHEADS: The app may have crashed in the last session.');
                // if (window.clarity) {
                //   window.clarity('set', 'session_bug', 'session_bug');
                // }
            }
            sessionStorage.setItem('th-cust-session', 'active');
        }
    };
    const deselectImage = () => {
        setSelectedImage(null);
    };
    const minimiseGallery = () => {
        setGalleryExpanded(false);
    };
    const expandGallery = () => {
        setGalleryExpanded(true);
    };
    const toggleCanvasZoom = () => {
        setCanvasZoomed((prevState) => !prevState);
    };
    useEffect(() => {
        const productGallery = document.querySelector('.product-gallery');
        if (productGallery) {
            if (!galleryExpanded) {
                productGallery.style.height = `calc(40vw + 50px)`;
                productGallery.classList.remove('product-gallery--snapped-open');
                productGallery.classList.add('product-gallery--snapped-closed');
            }
            else {
                productGallery.style.height = `calc(100vw + 50px)`;
                productGallery.classList.add('product-gallery--snapped-open');
                productGallery.classList.remove('product-gallery--snapped-closed');
            }
        }
    }, [galleryExpanded]);
    const captureFinalArtwork = () => __awaiter(void 0, void 0, void 0, function* () {
        const finalCanvas = finalArtworkRef.current;
        if (!finalCanvas)
            return null;
        // const quality = pixelRatio > 1 ? 4 : 2;
        const quality = 4;
        const uri = finalCanvas.toDataURL({ pixelRatio: quality });
        setFinalArtwork(uri);
    });
    const saveStageAsDataURL = (stage, width, height) => {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = width;
        tempCanvas.height = height;
        const tempContext = tempCanvas.getContext('2d');
        const stageCanvas = stage.toCanvas({ pixelRatio: 1 });
        tempContext.drawImage(stageCanvas, 0, 0, width, height);
        return tempCanvas.toDataURL();
    };
    const capturePreviewImage = () => __awaiter(void 0, void 0, void 0, function* () {
        const previewCanvas = canvasRef.current;
        const finalCanvasLoaded = finalPreviewRef.current;
        const finalProductImageLoaded = finalProductRef.current;
        if (!previewCanvas || !finalCanvasLoaded || !finalProductImageLoaded)
            return null;
        const [thumbnail, preview] = yield Promise.all([
            saveStageAsDataURL(previewCanvas, 600, 600),
            previewCanvas.toDataURL(),
        ]);
        yield setPreviewImage(preview);
        yield setThumbnailImage(thumbnail);
    });
    const triggerAddToCartModal = () => __awaiter(void 0, void 0, void 0, function* () {
        yield setSelectedImage(null);
        yield setGeneratingPreview(true);
        yield setRenderingExportCanvas(true);
        yield new Promise((resolve) => setTimeout(resolve, 0));
        const waitForText = textState.find((item) => item.text != '');
        const waitForImages = imageState.images.find((item) => item.uploadedImage != null);
        if (waitForText || waitForImages) {
            yield Promise.all(
            // Wait for text elements to load
            finalTextRefs.current.map((finalTextRef, index) => {
                if (textState[index].text == '') {
                    // Skip this item if no text
                    return Promise.resolve(null);
                }
                return new Promise((resolve) => {
                    // Poll until the textRef is ready
                    const interval = setInterval(() => {
                        if (finalTextRef.current) {
                            setTimeout(() => {
                                clearInterval(interval);
                                resolve(null);
                            }, 500);
                        }
                    }, 50); // Check every 50ms
                });
            }));
            yield Promise.all(
            // Wait for images to load
            finalImageRefs.current.map((imageRef, index) => {
                if (imageState.images[index].uploadedImage == null) {
                    // Skip this item if no image
                    return Promise.resolve(null);
                }
                return new Promise((resolve) => {
                    // Poll until the imageRef is ready
                    const interval = setInterval(() => {
                        if (imageRef.current) {
                            setTimeout(() => {
                                clearInterval(interval);
                                resolve(null);
                            }, 1000);
                        }
                    }, 50); // Check every 50ms
                });
            }));
            // After all required text and image refs are loaded, capture final artwork
            try {
                setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                    yield captureFinalArtwork();
                }), 1000);
            }
            catch (error) {
                console.error('THREADHEADS: Error generating preview image', error);
            }
        }
        else {
            // Capture without waiting if no text or images found initially
            try {
                yield captureFinalArtwork();
            }
            catch (error) {
                console.error('THREADHEADS: Error generating preview image', error);
            }
        }
    });
    useEffect(() => {
        if (finalArtwork != null) {
            const interval = setInterval(() => {
                if (finalPreviewRef.current && finalProductRef.current) {
                    capturePreviewImage();
                    clearInterval(interval); // Stop polling once the ref is set
                }
            }, 50); // Check every 50ms
            return () => clearInterval(interval); // Clean up interval on unmount
        }
    }, [finalArtwork]);
    useEffect(() => {
        if (previewImage != null && thumbnailImage != null && finalArtwork != null) {
            setGeneratingPreview(false);
            setAddToCartModalOpen(true);
            setUploadingFinalArtwork({
                status: 'started',
                urls: {
                    previewArtworkURL: '',
                    thumbnailArtworkURL: '',
                    finalArtworkURL: '',
                },
            });
            console.log('THREADHEADS: Starting to upload final artwork');
            const asyncFunction = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const [previewURL, finalURL, thumbnailURL] = yield Promise.all([
                        uploadToImageS3(previewImage, `assets/${dailyFolderName}/${sessionID}/preview.png`),
                        uploadToImageS3(finalArtwork, `${product.customiser_s3_folder != ''
                            ? `${product.customiser_s3_folder}/${dailyFolderName}`
                            : `${dailyFolderName}`}/${finalFileName}.png`),
                        uploadToImageS3(thumbnailImage, `thumbnails/${dailyFolderName}/${sessionID}.png`),
                    ]);
                    setUploadingFinalArtwork({
                        status: 'complete',
                        urls: {
                            previewArtworkURL: previewURL,
                            finalArtworkURL: finalURL,
                            thumbnailArtworkURL: thumbnailURL,
                        },
                    });
                }
                catch (error) {
                    console.error('THREADHEADS: Error uploading final artwork', error);
                }
                finally {
                    console.log('THREADHEADS: Upload complete');
                }
            });
            asyncFunction();
        }
    }, [previewImage]);
    const updateCartState = (variantID, quantity) => {
        const inCart = cartState.filter((cartItem) => cartItem.id == variantID);
        if (inCart.length > 0) {
            const updateIndex = cartState.indexOf(inCart[0]);
            const updatedCartState = cartState;
            if (updatedCartState[updateIndex].quantity + quantity <= 0) {
                // remove from cart object and disable
                const removeFromCart = updatedCartState.splice(updateIndex, 1);
                setCartState([...updatedCartState]);
            }
            else {
                updatedCartState[updateIndex] = {
                    id: variantID,
                    quantity: updatedCartState[updateIndex].quantity + quantity,
                };
                setCartState([...updatedCartState]);
            }
        }
        else {
            if (quantity < 0) {
                return;
            }
            setCartState([
                ...cartState,
                {
                    id: variantID,
                    quantity: quantity,
                },
            ]);
        }
    };
    const convertToBlob = (dataURI) => {
        const binary = atob(dataURI.split(',')[1]);
        const array = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            array[i] = binary.charCodeAt(i);
        }
        return new Blob([array], { type: 'image/png' });
    };
    const uploadToImageS3 = (dataURI, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        const blob = convertToBlob(dataURI);
        const params = {
            Bucket: settings.customiser_s3_bucket,
            Key: fileName,
            Body: blob,
            ContentType: 'image/png',
            ACL: 'public-read',
        };
        try {
            const uploadResult = yield s3.upload(params).promise();
            return uploadResult.Location;
        }
        catch (error) {
            console.error('Error uploading to S3:', error);
            throw error;
        }
    });
    useEffect(() => {
        // Add to cart flow
        if (uploadingFinalArtwork.status == 'complete' && addingToCart == true) {
            console.log('THREADHEADS: Adding to cart');
            const { finalArtworkURL, previewArtworkURL, thumbnailArtworkURL } = uploadingFinalArtwork.urls;
            const cartProperties = {
                _th_customiser: product.handle,
                _s3_folder: `assets/${dailyFolderName}/${sessionID}`,
                _final_artwork: finalArtworkURL,
                _preview_artwork: previewArtworkURL,
                _thumbnail_artwork: thumbnailArtworkURL,
                _filename: finalFileName + '.png',
                _artwork_barcode: finalFileName,
            };
            // Add reporting properties
            if (textState.length) {
                textState.map((textElem, index) => {
                    const textData = text[index];
                    if (textElem.text.length) {
                        cartProperties[`_cust-text-${index + 1}--name`] = textData.name;
                        cartProperties[`_cust-text-${index + 1}--font`] = textElem.activeFont;
                        cartProperties[`_cust-text-${index + 1}--colour-code`] = textElem.activeColour;
                        cartProperties[`_cust-text-${index + 1}--colour-name`] = textData.colours.find((col) => col.colour_code == textElem.activeColour).colour_name;
                    }
                });
            }
            if (selectedBackgroundImage) {
                cartProperties[`_cust-background-image`] = selectedBackgroundImage.name;
            }
            if (selectedSticker) {
                cartProperties[`_cust-sticker`] = selectedSticker.name;
            }
            if (selectedTextures) {
                let count = 1;
                for (const key in selectedTextures) {
                    const texture = selectedTextures[key];
                    if (Array.isArray(texture)) {
                        texture.forEach((innerTexture) => {
                            cartProperties[`_cust-texture-${count}`] = textures[innerTexture].name;
                            count += 1;
                        });
                    }
                    else if (texture != null) {
                        cartProperties[`_cust-texture-${count}`] = textures[texture].name;
                        count += 1;
                    }
                }
            }
            // Session info
            if (window.navigator.userAgent) {
                cartProperties[`_cust-session`] = window.navigator.userAgent;
            }
            const cartWithProperties = cartState.map((cartItem) => (Object.assign(Object.assign({}, cartItem), { properties: Object.assign({}, cartProperties) })));
            const sectionsToBundle = ['variant-added'];
            document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
            const asyncFunction = () => __awaiter(void 0, void 0, void 0, function* () {
                yield cartUtil
                    .add(cartWithProperties)
                    .then(() => __awaiter(void 0, void 0, void 0, function* () {
                    console.log('THREADHEADS: Designs added to cart');
                    setHasUnsavedChanges(false);
                    setNewSession();
                    setCartState([]);
                }))
                    .catch((e) => {
                    console.error('THREADHEADS: Error adding to cart', e);
                    // TODO: Adding to cart error
                })
                    .finally(() => {
                    setAddingToCart(false);
                    resetArtwork();
                    setTimeout(() => {
                        setUploadingFinalArtwork(initialUploadState);
                    }, 500);
                });
            });
            asyncFunction();
        }
    }, [uploadingFinalArtwork, addingToCart]);
    const addToCart = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setAddingToCart(true);
        setAddToCartModalOpen(false);
    }), []);
    const closeATCModal = () => {
        setAddToCartModalOpen(false);
        resetArtwork();
    };
    const resetArtwork = () => {
        setFinalArtwork(null);
        setPreviewImage(null);
        setThumbnailImage(null);
        setRenderingExportCanvas(false);
    };
    // Click on Inspo Thumbnails
    useEffect(() => {
        const thumbailsContainer = document.querySelector('.product-gallery__thumbnail-list-wrapper');
        if (thumbailsContainer) {
            thumbailsContainer.addEventListener('click', () => {
                setDesignModeChecked(false);
            });
        }
    }, []);
    // Session started
    const [unsavedChangesCallback, setUnsavedChangesCallback] = React.useState(() => (e) => {
        const message = 'You have unsaved changes, are you sure you want to leave?';
        sessionStorage.removeItem('th-cust-session');
        e.returnValue = message;
        return message;
    });
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    useEffect(() => {
        if (hasUnsavedChanges) {
            window.addEventListener('beforeunload', unsavedChangesCallback);
        }
        else {
            window.removeEventListener('beforeunload', unsavedChangesCallback);
        }
    }, [hasUnsavedChanges, unsavedChangesCallback]);
    // Size Guide
    const [SizeGuideModalOpen, setSizeGuideModalOpen] = useState(false);
    const openSizeGuideModal = () => {
        setSizeGuideModalOpen(true);
    };
    const closeSizeGuideModal = () => {
        setSizeGuideModalOpen(false);
    };
    if (!productData || canvasScaler.gallery == null || canvasMultiplier.gallery == null)
        return null;
    return (React.createElement(React.Fragment, null,
        createPortal(React.createElement(React.Fragment, null,
            React.createElement(Loader, { messages: ['Generating the final artwork', 'Adding your products to cart'], show: addingToCart }),
            React.createElement(Loader, { messages: ['Give us a sec!', 'Generating the artwork'], show: generatingPreview }),
            fileUploadError.isError != null && (React.createElement(WarningPopup, { title: errorMessages[fileUploadError.isError].heading, message: errorMessages[fileUploadError.isError].body, buttonLabel: strings.warning_cta_label, handleReset: () => handleResetWarnings() })),
            React.createElement(AddToCartModal, { strings: strings, settings: settings, closeModal: closeATCModal, previewImage: previewImage, modalOpen: addToCartModalOpen, isoCode: isoCode, cartState: cartState, variants: product.variants.filter((variant) => variant.option1 == selectedVariant.option1), updateCartState: updateCartState, addToCart: addToCart, templateCopy: templateCopy, openSizeGuideModal: openSizeGuideModal }),
            React.createElement(SizeGuideModal, { templateCopy: templateCopy, modalOpen: SizeGuideModalOpen, closeModal: closeSizeGuideModal })), atcContainer),
        createPortal(React.createElement(React.Fragment, null,
            React.createElement(GalleryCanvas, { aboveTextTextures: selectedTextures.aboveText, backgroundImage: selectedBackgroundImage, belowTextTextures: selectedTextures.belowText, borderMask: texture_mask, canvasDimensions: canvas, canvasMultiplier: canvasMultiplier.gallery, canvasScaler: canvasScaler.gallery, canvasZoomed: canvasZoomed, imageRefs: galleryImageRefs, imageState: imageState, productImage: selectedVariant.product_image, productImageRef: productImageRef, selectedImage: selectedImage, sticker: selectedSticker, textElements: text, textState: textState, textureElements: textures, textureMask: selectedTextures.mask, textRefs: textRefs, setActiveImage: setActiveImage, setSelectedImage: setSelectedImage, toggleCanvasZoom: toggleCanvasZoom, updateImageDimensions: updateImageDimensions }),
            React.createElement(ToolsContainer, { extraClass: "th-c-tools--desktop-only", disabled: selectedImage == null, strings: strings, handleToolClick: handleToolClick, handleLayerChange: handleLayerChange })), canvasContainer),
        createPortal(React.createElement(InspoButton, { strings: strings, checked: !designModeChecked, onClick: () => setDesignModeChecked(false) }), inspoButtonContainer),
        createPortal(React.createElement(DesignButton, { strings: strings, checked: designModeChecked, onClick: () => setDesignModeChecked(true) }), designButtonContainer),
        createPortal(React.createElement(PreviewButton, { strings: strings, galleryExpanded: galleryExpanded, onClick: expandGallery }), previewButtonContainer),
        createPortal(React.createElement(ShelfBar, { strings: strings, galleryExpanded: galleryExpanded, expandGallery: expandGallery, minimiseGallery: minimiseGallery }), shelfContainer),
        React.createElement("div", { className: "th-customiser", onClick: setCustomiserActive },
            images.length > 0 ? (React.createElement(ImagesContainer, { imageState: imageState, imageToolsRef: imageToolsRef, strings: strings, uploadedImagesCount: uploadedImagesCount, handleImageUpload: handleImageUpload, setSelectedImage: setSelectedImage, selectedImage: selectedImage, maxUploadsCount: images.length, removeImageFromS3: removeImageFromS3, cutOutInitial: cut_out_images, maxFileSize: max_file_size, maxDims: max_dimensions, minDims: min_dimensions, setImageLoading: setImageLoading, sessionID: sessionID, dailyFolderName: dailyFolderName, bucketName: settings.customiser_s3_bucket, handleToolClick: handleToolClick, handleLayerChange: handleLayerChange, showCutOutToggle: templateSettings.th_c_cutout_toggle, useRyanAI: use_ryanai, templateCopy: templateCopy })) : null,
            text.length > 0 ? (React.createElement(TextContainer, { textElements: text, strings: strings, handleTextInput: handleTextInput, handleFontChange: handleFontChange, handleTextColourChange: handleTextColourChange, textState: textState, textInputRefs: textInputRefs, deselectImage: deselectImage, handleFontSizeChange: handleFontSizeChange, handleFocusTextInput: handleFocusTextInput })) : null,
            background_images.length > 0 ? (React.createElement(ExtrasContainer, { backgroundImages: background_images, stickers: overlay_stickers, textures: textures, strings: strings, selectedBackgroundImage: selectedBackgroundImage, selectedSticker: selectedSticker, selectedTextures: selectedTextures, setSelectedBackgroundImage: setBackgroundOnClick, setSelectedSticker: setStickerOnClick, setSelectedTextures: setSelectedTextures, deselectImage: deselectImage })) : null,
            React.createElement(AddToCartButton, { buttonText: templateCopy.th_c_review_button, triggerAddToCartModal: triggerAddToCartModal })),
        createPortal(React.createElement(React.Fragment, null, hasUnsavedChanges && renderingExportCanvas && (React.createElement(React.Fragment, null,
            React.createElement(ExportCanvas, { aboveTextTextures: selectedTextures.aboveText, backgroundImage: selectedBackgroundImage, belowTextTextures: selectedTextures.belowText, borderMask: texture_mask, canvasDimensions: canvas, finalArtworkRef: finalArtworkRef, finalTextRefs: finalTextRefs, imageRefs: finalImageRefs, imageState: imageState, textElements: text, textState: textState, sticker: selectedSticker, textureElements: textures, textureMask: selectedTextures.mask, pixelRatio: pixelRatio, deviceScaler: deviceScaler }),
            React.createElement(PreviewCanvas, { previewRef: canvasRef, finalProductRef: finalProductRef, backgroundImage: selectedVariant.product_image, canvasImage: finalArtwork, canvasDimensions: canvas, previewFinalCanvasRef: finalPreviewRef, scaler: canvasScaler.exportPreview })))), exportContainer)));
};
export default CustomiserBase;
